export default __webpack_public_path__ + "img/chevron-down-black.199370c6.svg";